import React from 'react';
import SymposiumList from '../features/symposium/SymposiumList';
const Symposiums = () => {
    return (
        <div>
            <SymposiumList />
        </div>
    );
};

export default Symposiums;